import React, { useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Context as RestaurantContext } from '../context/restaurant';
import { Context as CheckoutContext } from '../context/checkout';
import { Context as AuthContext } from '../context/auth';
import MainLayout from '../layouts/mainLayout';
import Loader from '../components/misc/loader';
import { restaurantTypes } from '../enums/restaurantTypes';
import TopBar from '../layouts/place/topBar';
import CustomOrder from '../features/order/components/customOrder/customOrder';
import { useTableSseConnection } from '../hooks/useTableSseConnection';
import { useInterval } from '../hooks/useInterval';

const OrderPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useTableSseConnection();

  const { state: restaurantState, getOrders } = useContext(RestaurantContext);
  const { rateOrder } = useContext(CheckoutContext);
  const { state: authState } = useContext(AuthContext);

  const { orderId } = useParams();

  const getOrdersAsync = async (isFirstRequest) => {
    const { locked, orders } = await getOrders({
      tableId: restaurantState.table.id,
      userId: authState.user ? authState.user.id : null,
      restaurantType: restaurantState.restaurant.type,
      inBackground: !isFirstRequest,
    });

    const foundOrder = orders ? orders.find((x) => x.id === orderId) : null;

    if (!locked && !foundOrder) {
      navigate('/orders', { replace: true });
    }
  };

  useEffect(() => {
    if (restaurantState.restaurant.type !== restaurantTypes.OrderAndPay) {
      navigate('/', { replace: true });
      return;
    }

    if (restaurantState.ordersGot) {
      return;
    }

    getOrdersAsync(true);
  }, [restaurantState.ordersGot]);

  // reget orders every 30s (if there is problem with server events)
  useInterval(getOrdersAsync, 30000, false);

  // Loading table
  if (restaurantState.loadingOrders || !restaurantState.ordersGot) {
    return <Loader />;
  }

  const updateRating = (ratingOrderId, rating, comment) => {
    const order = restaurantState.orders
      ? restaurantState.orders.find((x) => x.id === ratingOrderId)
      : null;
    const payment = order && order.payments && order.payments.length > 0 ? order.payments[0] : null;

    rateOrder({
      token: authState.token,
      orderId: order ? order.id : null,
      paymentId: payment ? payment.id : null,
      userId: authState.user.id,
      restaurantId: restaurantState.restaurant.id,
      rating,
      comment,
    });
  };

  const selectedOrder = restaurantState.orders
    ? restaurantState.orders.find((x) => x.id === orderId)
    : null;

  return (
    <MainLayout>
      <div className="sticky top-0 bg-white z-10">
        <TopBar title={t('header.yourOrder')} onBack={() => navigate('/orders')} />
      </div>

      {!!selectedOrder && (
        <CustomOrder
          order={selectedOrder}
          table={restaurantState.table}
          canRate={authState.user && authState.user.id && authState.token}
          restaurant={restaurantState.restaurant}
          onUpdateRating={updateRating}
        />
      )}
    </MainLayout>
  );
};

export default OrderPage;
